export const postback = {
  state: {
    init: {
      description:
        'Postback adalah layanan PBX virtual yang memungkinkan Anda mengirim pesan dengan parameter yang diperlukan ke URL yang ditentukan setelah menyelesaikan transisi sesuai dengan skema perutean.'
    }
  },
  url: 'URL',
  key: 'Key',
  value: 'Value',
  area: 'Enter something...'
};
